import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";

import useAppState from "../../context/AppContext";
import REPostSignatureActionBloc from "../../blocs/retirement/post-signature/REPostSignatureActionBloc";

export default function REPostSignatureActionPage() {

  const {  state: { proposition } } = useAppState();
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Proposition {proposition?.propositionName }</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <REPostSignatureActionBloc />
        </div>
      </div>
    
    )

}